import { _ as _extends } from '../../_rollupPluginBabelHelpers-mO86zOh3.js';
import React, { forwardRef, useRef, useEffect } from 'react';
import { themed } from '@indeed/ifl-css';
import { Chip } from './Chip.js';
import { matchesDisplayName } from '../../utils/displayName.js';
import { jsx } from '@emotion/react';
import { Box } from '../Box/Box.js';
import '@emotion/is-prop-valid';
import '@indeed/ihl-use-id';
import '@indeed/ifl-icons';
import '../../hooks/useResponsiveValue.js';
import '../../hooks/useBreakpointIndex.js';
import '../../utils/transition.js';
import '../../constants/index.js';
import '../Button/Button.js';
import '../../utils/styled.js';
import '../../utils/createResponsive.js';
import '../../utils/transparentize.js';
import '../Button/context.js';
import '../Spinner/Spinner.js';
import '../IconWrapper/IconWrapper.js';
import '../Label/Label.js';
import '../VisuallyHidden/VisuallyHidden.js';
import '../Flex/Flex.js';

const baseStyles = () => ({
  display: "flex",
  flexWrap: "wrap",
  listStyleType: "none",
  paddingBlock: 0,
  paddingInline: 0,
  marginBlock: 0,
  marginInline: 0,
  gap: 2
});
const ChipList = /*#__PURE__*/themed("ul", process.env.NODE_ENV === "production" ? {
  target: "ehgddzl0"
} : {
  target: "ehgddzl0",
  label: "ChipList"
})(baseStyles, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
const ChipGroup = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    className,
    children,
    listProps,
    sx,
    tabIndex,
    onFocus,
    onBlur,
    id,
    ...chipProps
  } = _ref;
  const {
    type = "single"
  } = chipProps;
  const listRef = useRef(null);
  useEffect(() => {
    if (type === "removable" && listRef.current !== null) {
      // Allow first chip to be focusable if no other chips have tabindex of 0
      const cells = listRef.current.querySelectorAll("[tabindex]");
      const tabbableCells = listRef.current.querySelectorAll('[tabindex="0"]');
      if (cells.length > 0 && tabbableCells.length === 0) {
        cells[0].setAttribute("tabindex", "0");
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [children]);
  const focusCell = dir => {
    if (listRef.current === null) {
      return;
    }
    const cells = listRef.current.querySelectorAll("[tabindex]");
    // Find currently focused cell
    let currentCellIndex = 0;
    for (let i = 0; i < cells.length; i++) {
      const thisCell = cells[i];
      if (thisCell && thisCell.attributes.getNamedItem("tabindex")?.value === "0") {
        currentCellIndex = i;
      }
    }
    const previousIndex = currentCellIndex;
    let nextIndex = previousIndex;
    switch (dir) {
      case "next":
        nextIndex = Math.min(cells.length - 1, previousIndex + 1);
        break;
      case "prev":
        nextIndex = Math.max(0, previousIndex - 1);
        break;
      case "first":
        nextIndex = 0;
        break;
      case "last":
        nextIndex = cells.length - 1;
        break;
      case "nextOrPrev":
        nextIndex = Math.min(cells.length - 1, previousIndex + 1);
        if (nextIndex === currentCellIndex) {
          nextIndex = Math.max(0, currentCellIndex - 1);
        }
        break;
    }
    if (nextIndex !== previousIndex && previousIndex < cells.length) {
      cells[previousIndex].setAttribute("tabindex", "-1");
    }
    cells[nextIndex].setAttribute("tabindex", "0");
    cells[nextIndex].focus();
  };
  const handleKeyDown = e => {
    let handled = true;
    switch (e.key) {
      case "ArrowDown":
      case "Down":
      case "ArrowRight":
      case "Right":
        focusCell("next");
        break;
      case "ArrowLeft":
      case "Left":
      case "ArrowUp":
      case "Up":
        focusCell("prev");
        break;
      case "Home":
        focusCell("first");
        break;
      case "End":
        focusCell("last");
        break;
      default:
        handled = false;
    }
    if (handled) {
      e.preventDefault();
    }
  };
  const chipListProps = type === "removable" ? {
    onKeyDown: handleKeyDown,
    ...listProps
  } : {
    ...listProps
  };
  return jsx(Box, {
    id: id,
    className: className,
    sx: sx,
    ref: ref,
    tabIndex: tabIndex,
    onFocus: onFocus,
    onBlur: onBlur
  }, jsx(ChipList, _extends({
    ref: listRef
  }, chipListProps), React.Children.map(children, child => {
    if (! /*#__PURE__*/React.isValidElement(child) || !matchesDisplayName([Chip], child)) {
      return child;
    }
    const chip = /*#__PURE__*/React.cloneElement(child, {
      ...child.props,
      ...chipProps,
      onRemove: () => {
        focusCell("nextOrPrev");
        if (child.props.onRemove !== undefined) {
          child.props.onRemove();
        }
      }
    });
    return jsx(Box, {
      as: "li"
    }, chip);
  })));
});
ChipGroup.displayName = "ChipGroup";

export { ChipGroup };
